import flow from 'lodash/flow'
import has from 'lodash/has'

import { unref } from 'vue'

import { findReserveScreen } from '@ga/utils'

import { extractExtension, sortByBreakpoint } from '../../utils'
import { useImageBreakpoints } from '../image-breakpoints'

export const useImageStrategyPlain = (config) => {
  const { breakpoints } = useImageBreakpoints()

  const getName = () => 'plain'

  /**
   * Метод позволяет определить стратегию на основе конфига изображения
   * Если конфиг содержит в качестве ключей имена брейкпоинтов, то это текущая стратегия
   */
  const isOwnStrategy = () => {
    return unref(breakpoints).keys.some((key) => has(config, key))
  }

  const getScreensForBuild = () => {
    // Сортируем пришедшие экраны в порядке убывания
    const sorted = sortByBreakpoint(Object.keys(unref(config)))

    // Находим индекс первого экрана, в массиве всех экранов
    const first = unref(breakpoints).keys.indexOf(sorted[0])

    // Делаем слайс диапазона экранов от наивысшего пришедшего до наименьшего
    return unref(breakpoints).keys.slice(first)
  }

  const buildSources = (currentScreen, image) => {
    const { values: bpValues, keys: bpKeys } = unref(breakpoints)

    const configScreens = Object.keys(unref(config))

    const currentAvaScreen = unref(image)[currentScreen]
      ? currentScreen
      : findReserveScreen(currentScreen, bpKeys, configScreens, true)

    const url = unref(image)[currentAvaScreen]

    return [
      {
        ext: extractExtension(url),
        media: bpValues[currentScreen],
        srcset: [url],
      },
    ]
  }

  const buildSourceFallback = (image) => {
    const keys = flow(Object.keys, sortByBreakpoint)(unref(image))

    return keys && unref(image)[keys[0]]
  }

  return {
    getName,
    isOwnStrategy,
    getScreensForBuild,
    buildSourceFallback,
    buildSources,
  }
}
